import Parse, { Role, User } from "parse";
import { useEffect, useState } from "react";
import { useSubordinateRoles } from "../../../../_shared/role/hooks/useSubordinateRoles";
import { _User, Project } from "../../../../js/parsegenerated";

/**
 * Returns all projects or the subprojects of the given project
 * @param project if given, the projects of the given project will be returned.
 * @param loadFinished if true, finished projects will be loaded as well
 * @returns an array of projects
 */
export const useProjects = (project?: Project, loadFinished?: boolean) => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(false);
  const roles = useSubordinateRoles(Parse.User.current() as _User);

  useEffect(() => {
    const user = Parse.User.current();
    const userQuery = new Parse.Query(User).equalTo("objectId", user?.id);
    const roleQuery = new Parse.Query(Role).containedIn(
      "objectId",
      roles.map((role) => role.id)
    );
    const projectRoleQuery = new Parse.Query(Project).matchesQuery(
      "assignedRoles",
      roleQuery
    );
    const projectUserQuery = new Parse.Query(Project).matchesQuery(
      "assignedUsers",
      userQuery
    );
    const projectQuery = Parse.Query.or(projectRoleQuery, projectUserQuery);
    if (!loadFinished) projectQuery.notEqualTo("finished", true);

    setLoading(true);
    if (!project) {
      projectQuery
        .limit(1000)
        .includeAll()
        .find()
        .then(setProjects)
        .catch((e) => console.warn(e))
        .finally(() => setLoading(false));
    } else {
      projectQuery
        .equalTo("parent", project)
        .limit(1000)
        .includeAll()
        .find()
        .then(setProjects)
        .catch((e) => console.warn(e))
        .finally(() => setLoading(false));
    }
  }, [project, roles, loadFinished]);

  return { projects, loading };
};
